import { extend } from '../util/index.js';
import Toast$1 from './toast.js';
export { default as Toast } from './toast.js';
import Toaster from './toaster.js';
export { default as Toaster } from './toaster.js';

var Toast = extend(Toast$1, Toaster);

export { Toast as default };
//# sourceMappingURL=index.js.map
